export default [
  {
    id: 1,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">물(안전보건규칙 제571조)</div>' +
      '<div>- 깨끗하고 시원한 물을 제공하는지</div>' +
      '</div>',
    is_checked: '',
    note: '',
  },
  {
    id: 2,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">휴식(안전보건규칙 제566조)</div>' +
      '<div> - 휴식시간이 적절히 부여되는지</div>' +
      '</div>',
    is_checked: '',
    note: '',
  },
  {
    id: 3,
    html: '<label style="cursor: pointer;"><input id="indoor_ck_3_01" type="checkbox" checked style="accent-color: #7E72F2; "><span style="padding-left: 4px; padding-right: 8px;">휴게실</span></input></label>' +
      '<label style="cursor: pointer;"><input id="indoor_ck_3_02" type="checkbox" checked style="accent-color: #7E72F2; "><span style="padding-left: 4px; padding-right: 8px;">근무장소</span></input></label>' +
      '에 냉방장치가 설치되어 있는지',
    is_checked: '',
    indoor_ck_3_01: false,
    indoor_ck_3_02: false,
    note: '',
    title: '관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지',
    titleColor: '#F9F9F9',
  },
  {
    id: 4,
    html: '<label style="cursor: pointer;"><input id="indoor_ck_4_01" type="checkbox" checked style="accent-color: #7E72F2; " ><span style="padding-left: 4px; padding-right: 8px;">휴게실</span></input></label>' +
      '<label style="cursor: pointer;"><input id="indoor_ck_4_02" type="checkbox" checked style="accent-color: #7E72F2; " ><span style="padding-left: 4px; padding-right: 8px;">근무장소</span></input></label>' +
      '에 관리온도 범위를 정하고 유지하는지',
    is_checked: '',
    indoor_ck_4_01: false,
    indoor_ck_4_02: false,
    note: '',
    title: '관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지',
  },
  {
    id: 5,
    label: '야간작업을 하는 경우에도 실내온도를 관리하고 있는지',
    is_checked: '',
    note: '',
    title: '관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지',
  },
  {
    id: 6,
    label: '온열질환 예방가이드 게시 여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
    titleColor: '#F9F9F9',
  },
  {
    id: 7,
    label: '폭염 위험단계별 대응요령 숙지 및 준수여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
  {
    id: 8,
    label: '폭염시 근로자가 건강상의 이유로 작업중지를 요청할 경우 즉시 조치',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
  {
    id: 9,
    label: '온열질환 예방에 관한 교육 여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
];
